import { createAction } from '@reduxjs/toolkit';

import { CookieTypes } from '@definitions/gdprConsents.types';

const PREFIX = 'GDPR_CONSENTS';

export const setConsents = createAction<CookieTypes>(`${PREFIX}/SET_CONSENTS`);
